import { useCallback } from 'react';
import { apiService } from '../../../service/api.service';
import apiEndPoints from '../../routeConfig';
import axiosInstance from '../../../service/axios.instance';

export class UserProfileService {
  async getCurrentUserProfile() {
    try {
      const response = await apiService.get(apiEndPoints.userProfile);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateUserProfile(data) {
    try {
      const response = await apiService.update(apiEndPoints.updateUserProfile, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async uploadProfileImage(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axiosInstance.post(
        apiUrl + apiEndPoints.uploadProfileImage,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deleteProfileImage() {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axiosInstance.delete(apiUrl + apiEndPoints.deleteProfileImage);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const useUserProfile = () => {
  const fetchUserProfile = useCallback(async () => {
    const userProfileService = new UserProfileService();
    return await userProfileService.getCurrentUserProfile();
  }, []);

  const updateUserProfileData = useCallback(async (data) => {
    const userProfileService = new UserProfileService();
    return await userProfileService.updateUserProfile(data);
  }, []);

  const uploadImage = useCallback(async (file) => {
    const userProfileService = new UserProfileService();
    return await userProfileService.uploadProfileImage(file);
  }, []);

  const deleteImage = useCallback(async () => {
    const userProfileService = new UserProfileService();
    return await userProfileService.deleteProfileImage();
  }, []);

  return { fetchUserProfile, updateUserProfileData, uploadImage, deleteImage };
};
